import { Component, Input } from '@angular/core';

/**
 * Placeholder matching a blog card — the same skeleton used on the Stories list.
 * Reused on the author page for the loading state and to fill out short article
 * rows. Set `animated` to false for permanent fillers: a moving shimmer implies
 * "still loading", which would confuse users when nothing is actually loading.
 */
@Component({
  selector: 'app-blog-card-skeleton',
  standalone: false,
  templateUrl: './blog-card-skeleton.component.html',
  styleUrls: ['./blog-card-skeleton.component.scss'],
})
export class BlogCardSkeletonComponent {
  @Input() animated = true;
}
